// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteBtn_root__w7LDY"};